import index from '@/components/conf/index/index.vue'
import empty from '@/components/common/empty/empty.vue'

export default {
  path: '/content-manage',
  component: index,
  redirect: '/content-manage/home',
  name: '内容管理',
  iconCls: '&#xe794;',
  children: [{
    path: 'home',
    component: empty,
    name: '首页数据配置',
    iconCls: '&#xe634;',
    hiddenChildren: true,
    redirect: '/content-manage/home/list',
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/index.vue'], resolve),
      name: '首页数据配置列表'
    }, {
      path: '@advertise-add',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/advertise/add.vue'], resolve),
      name: '添加广告'
    }, {
      path: '@commodity-add',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/commodity/add.vue'], resolve),
      name: '添加商品'
    }, {
      path: '@product-buy',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/product-buy/add.vue'], resolve),
      name: '大家还在买'
    }, {
      path: '@coupon-add',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/coupon/add.vue'], resolve),
      name: '添加优惠券'
    }, {
      path: '@activity-add',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/activity/add.vue'], resolve),
      name: '添加商品促销活动'
    }, {
      path: '@product-add',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/actcommody/add.vue'], resolve),
      name: '添加广告商品'
    }, {
      path: '@mcproduct-add',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/actcommody/mcproduct-add.vue'], resolve),
      name: '添加魔方品类'
    }, {
      path: '@commonproduct-add',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/actcommod/add.vue'], resolve),
      name: '添加普通商品'
    }, {
      path: '@mccommonproduct-add',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/actcommod/mcchannel-add.vue'], resolve),
      name: '添加魔方频道'
    }, {
      path: '@manage-product',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/actcommody/manage.vue'], resolve),
      name: '管理商品'
    }, {
      path: '@manage-product-add',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/actcommody/manage-add.vue'], resolve),
      name: '添加管理商品'
    }, {
      path: '@combination-add',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/combination/add.vue'], resolve),
      name: '添加组合广告'
    }, {
      path: '@combination-manage',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/combination/combination.vue'], resolve),
      name: '管理子广告'
    }, {
      path: '@combination-manage-add',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/combination/combination-add.vue'], resolve),
      name: '添加管理子广告'
    }, {
      path: '@buttons-add',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/buttons/add.vue'], resolve),
      name: '添加任意门'
    }, {
      path: '@index-buttons-add',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/index-btns/add.vue'], resolve),
      name: '添加跳转按钮'
    }, {
      path: '@exciting-add',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/exciting/add.vue'], resolve),
      name: '添加活动内容'
    }, {
      path: '@hot-words-add',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/search-hot-words/add.vue'], resolve),
      name: '添加热词'
    }, {
      path: '@new-exclusive-add',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/new-exclusive/add.vue'], resolve),
      name: '添加新人专享'
    }, {
      path: '@recommend-ads-add',
      component: resolve => require(['@/components/conf/content-manage/home-configuration/recommend-ads/add.vue'], resolve),
      name: '新增首页推荐广告'
    }]
  }, {
    path: 'department-store',
    component: empty,
    name: '百货首页配置',
    iconCls: '&#xe634;',
    hiddenChildren: true,
    redirect: '/content-manage/department-store/list',
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/content-manage/department-store/index.vue'], resolve),
      name: '百货首页配置列表'
    }, {
      path: '@banner-add',
      component: resolve => require(['@/components/conf/content-manage/department-store/banner/add.vue'], resolve),
      name: '百货添加轮播图'
    }, {
      path: '@icon-add',
      component: resolve => require(['@/components/conf/content-manage/department-store/theme-icon/add.vue'], resolve),
      name: '百货添加icon'
    }, {
      path: '@marquee-add',
      component: resolve => require(['@/components/conf/content-manage/department-store/marquee/add.vue'], resolve),
      name: '百货添加跑马灯'
    }, {
      path: '@advertisement-add',
      component: resolve => require(['@/components/conf/content-manage/department-store/full-column/add.vue'], resolve),
      name: '百货添加通栏广告'
    }, {
      path: '@float-add',
      component: resolve => require(['@/components/conf/content-manage/department-store/float-window/add.vue'], resolve),
      name: '百货添加浮窗'
    }, {
      path: '@shoppe-add',
      component: resolve => require(['@/components/conf/content-manage/department-store/rec-shoppe/add.vue'], resolve),
      name: '百货添加专柜推荐'
    }, {
      path: '@brand-add',
      component: resolve => require(['@/components/conf/content-manage/department-store/rec-brand/add.vue'], resolve),
      name: '百货添加品牌推荐'
    }, {
      path: '@cube-add',
      component: resolve => require(['@/components/conf/content-manage/department-store/magical-cube/add.vue'], resolve),
      name: '百货添加魔方'
    }, {
      path: '@theme-add',
      component: resolve => require(['@/components/conf/content-manage/department-store/theme/add.vue'], resolve),
      name: '百货添加主题背景'
    }]
  }, {
    path: 'advertising',
    component: empty,
    name: '广告位图片管理',
    iconCls: '&#xe7f8;',
    hiddenChildren: true,
    redirect: '/content-manage/advertising/list',
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/content-manage/image-management/index.vue'], resolve),
      name: '广告位图片管理列表'
    },{
      path: '@add',
      component: resolve => require(['@/components/conf/content-manage/image-management/add-new.vue'], resolve),
      name: '添加广告位图片'
    }]
  },
  {
    path: 'global-config',
    component: resolve => require(['@/components/conf/content-manage/global-config/index.vue'], resolve),
    name: '全局配置',
    iconCls: '&#xe7f8;'
  },
  {
    path: 'circle-config',
    component: resolve => require(['@/components/conf/content-manage/circle-config/index.vue'], resolve),
    name: '商圈配置',
    iconCls: '&#xe7f8;'
  }, {
    path: 'sharing-earnings',
    component: empty,
    name: '全国发货首页配置',
    iconCls: '&#xe634;',
    hiddenChildren: true,
    redirect: '/content-manage/sharing-earnings/list',
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/content-manage/sharing-earnings/index.vue'], resolve),
      name: '全国发货首页数据配置'
    }, {
      path: '@advertise-add',
      component: resolve => require(['@/components/conf/content-manage/sharing-earnings/advertise/add.vue'], resolve),
      name: '添加广告'
    }, {
      path: '@commodity-add',
      component: resolve => require(['@/components/conf/content-manage/sharing-earnings/commodity/add.vue'], resolve),
      name: '添加商品'
    }, {
      path: '@classify-add',
      component: resolve => require(['@/components/conf/content-manage/sharing-earnings/classify/add.vue'], resolve),
      name: '添加分类'
    },
    {
      path: '@index-icon-add',
      component: resolve => require(['@/components/conf/content-manage/sharing-earnings/icon/add.vue'], resolve),
      name: '添加icon'
    }, {
      path: '@hot-product-add',
      component: resolve => require(['@/components/conf/content-manage/sharing-earnings/hot-product/add.vue'], resolve),
      name: '添加爆品推荐'
    },{
      path: '@addone',
      component: resolve => require(['@/components/conf/content-manage/sharing-earnings/category/addone.vue'], resolve),
      name: '前台展示管理-新增1',
      hidden: true
    }, {
      path: '@addtwo',
      component: resolve => require(['@/components/conf/content-manage/sharing-earnings/category/addtwo.vue'], resolve),
      name: '前台展示管理-新增2',
      hidden: true
    }, {
      path: '@eddone',
      component: resolve => require(['@/components/conf/content-manage/sharing-earnings/category/editone.vue'], resolve),
      name: '前台展示管理-编辑1',
      hidden: true
    }, {
      path: '@eddtwo',
      component: resolve => require(['@/components/conf/content-manage/sharing-earnings/category/edittwo.vue'], resolve),
      name: '前台展示管理-编辑2',
      hidden: true
    }, {
      path: '@finish',
      component: resolve => require(['@/components/conf/content-manage/sharing-earnings/category/addfinish.vue'], resolve),
      name: '前台展示管理-新增完成',
      hidden: true
    }, {
      path: '@edit-finish',
      component: resolve => require(['@/components/conf/content-manage/sharing-earnings/category/editfinish.vue'], resolve),
      name: '前台展示管理-编辑完成',
      hidden: true
    }]
  }, {
    path: 'pop-home',
    component: resolve => require(['@/components/conf/content-manage/pop-home/index.vue'], resolve),
    component: empty,
    name: 'POP商城首页数据配置',
    iconCls: '&#xe634;',
    hiddenChildren: true,
    redirect: '/content-manage/pop-home/list',
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/content-manage/pop-home/index.vue'], resolve),
      name: 'POP商城首页数据配置列表'
    }, {
      path: '@advertise-add',
      component: resolve => require(['@/components/conf/content-manage/pop-home/advertise/add.vue'], resolve),
      name: '添加轮播图'
    }, {
      path: '@actcommod-add',
      component: resolve => require(['@/components/conf/content-manage/pop-home/actcommod/add.vue'], resolve),
      name: '添加普通广告'
    }, {
      path: '@activity-add',
      component: resolve => require(['@/components/conf/content-manage/pop-home/activity/add.vue'], resolve),
      name: '添加限时抢购'
    }, {
      path: '@magic-add',
      component: resolve => require(['@/components/conf/content-manage/pop-home/magic/add.vue'], resolve),
      name: '添加魔方品类'
    }, {
      path: '@magic-product',
      component: resolve => require(['@/components/conf/content-manage/pop-home/magic/manage.vue'], resolve),
      name: '添加魔方品类管理商品'
    }, {
      path: '@magic-product-add',
      component: resolve => require(['@/components/conf/content-manage/pop-home/magic/manage-add.vue'], resolve),
      name: '魔方品类管理商品新增编辑'
    }, {
      path: '@category-add',
      component: resolve => require(['@/components/conf/content-manage/pop-home/category/add.vue'], resolve),
      name: '添加类目商品推荐'
    }, {
      path: '@category-product',
      component: resolve => require(['@/components/conf/content-manage/pop-home/category/manage.vue'], resolve),
      name: '添加类目商品推荐管理商品'
    }, {
      path: '@category-product-add',
      component: resolve => require(['@/components/conf/content-manage/pop-home/category/manage-add.vue'], resolve),
      name: '类目商品推荐管理商品新增编辑'
    }, {
      path: '@buttons-add',
      component: resolve => require(['@/components/conf/content-manage/pop-home/buttons/add.vue'], resolve),
      name: '添加商城跳转按钮'
    }, {
      path: '@seckill-add',
      component: resolve => require(['@/components/conf/content-manage/pop-home/seckill/add.vue'], resolve),
      name: '添加秒杀按钮'
    }]
  }, {
    path: 'local-life',
    component: resolve => require(['@/components/conf/content-manage/local-life/index.vue'], resolve),
    component: empty,
    name: '本地生活首页数据配置',
    iconCls: '&#xe634;',
    hiddenChildren: true,
    redirect: '/content-manage/local-life/list',
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/content-manage/local-life/index.vue'], resolve),
      name: '本地生活首页数据配置列表'
    }, {
      path: '@advertise-add',
      component: resolve => require(['@/components/conf/content-manage/local-life/advertise/add.vue'], resolve),
      name: '添加轮播图'
    }, {
      path: '@buttons-add',
      component: resolve => require(['@/components/conf/content-manage/local-life/buttons/add.vue'], resolve),
      name: '添加本地生活跳转按钮'
    }, {
      path: '@commodity-add',
      component: resolve => require(['@/components/conf/content-manage/local-life/commodity/add.vue'], resolve),
      name: '添加推荐商品'
    }, {
      path: '@shop-add',
      component: resolve => require(['@/components/conf/content-manage/local-life/shop/add.vue'], resolve),
      name: '添加好店推荐'
    }, {
      path: '@category-add',
      component: resolve => require(['@/components/conf/content-manage/local-life/category/add.vue'], resolve),
      name: '添加类目商品推荐'
    }, {
      path: '@category-product',
      component: resolve => require(['@/components/conf/content-manage/local-life/category/manage.vue'], resolve),
      name: '添加类目商品推荐管理商品'
    }, {
      path: '@category-product-add',
      component: resolve => require(['@/components/conf/content-manage/local-life/category/manage-add.vue'], resolve),
      name: '类目商品推荐管理商品新增编辑'
    }]
  }, {
    path: 'member-consumption',
    component: resolve => require(['@/components/conf/activity-manage/group-search/member-consumption.vue'], resolve),
    name: '企业or高端会员消费查询',
    iconCls: '&#xe634;'
  }]
}



// WEBPACK FOOTER //
// ./src/router/content-manage.js